export default __webpack_public_path__ + "static/media/nextFloor.a3f258b3.png";